import { render, staticRenderFns } from "./eliminar.vue?vue&type=template&id=2c31681e&scoped=true&"
import script from "./eliminar.vue?vue&type=script&lang=js&"
export * from "./eliminar.vue?vue&type=script&lang=js&"
import style0 from "./eliminar.vue?vue&type=style&index=0&id=2c31681e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c31681e",
  null
  
)

export default component.exports